import { AbstractSearchCore } from './AbstractSearchCore'
import { AbstractSubscriber } from './AbstractSubscriber'
import { IFacet } from './IFacet'
import { IResult } from './IResult'
import { MultipleResults } from './result'
import { ISearchConfig } from './ISearchConfig'

export class SearchBarSubscriber extends AbstractSubscriber {
  core: AbstractSearchCore | undefined | null
  _updateCallback: (searchConfig: ISearchConfig) => void

  constructor(groupId: string, updatedCallback?: (searchConfig: ISearchConfig) => void) {
    super(groupId)
    this._updateCallback = updatedCallback || (() => {})
  }
  public async attached(searchCore: AbstractSearchCore): Promise<void> {
    this.core = searchCore
    await this.whenReady()
    this.pushUpdate()
  }

  public async doSearch(myString: string): Promise<void> {
    await this.updateQuery(myString)
    this.goToSearch(true)
  }

  public async updateQuery(myString: string, modal?: string): Promise<void> {
    await this.whenReady()
    await this.core?.applySearchConfig({ query: myString, modal: modal }, false)
  }
  public async executeSearch(searchConfig: ISearchConfig): Promise<void> {
    await this.whenReady()
    await this.core?.executeSearch(searchConfig)
  }
  public goToSearch(redirectToSearch = true, resetPagination = false): void {
    this.core?.goToSearch(redirectToSearch, resetPagination)
  }

  public async hasAnyFilters(): Promise<boolean> {
    let searchConfig = this.core?.searchConfig
    let anyFilters = false

    if (searchConfig?.query) anyFilters = true

    if ((searchConfig?.dateFilters?.length ?? 0) > 0) {
      anyFilters = true
    }

    for (let i = 0; i < (searchConfig?.facets?.length ?? 0); i++) {
      let facet: IFacet = (searchConfig?.facets?.[i] ?? {}) as IFacet
      if (facet?.options?.length > 0 && facet.name !== 'hasPublishedEvents') {
        anyFilters = true
        break
      }
    }
    let aroundLatLng = searchConfig?.options?.aroundLatLng || {}

    for (let k in aroundLatLng) {
      if (aroundLatLng[k]) {
        anyFilters = true
        break
      }
    }

    return anyFilters
  }

  public async clearAll(redirectToSearch = true): Promise<void> {
    await this.core?.clearAll(redirectToSearch)
  }

  detaching(): void {
    this.core = null
  }

  public pushUpdate() {
    let searchConfig = this.core?.searchConfig
    if (searchConfig) {
      this._updateCallback?.(searchConfig)
    }
  }

  async onSearchConfigUpdate(searchConfig: ISearchConfig): Promise<void> {
    this.pushUpdate()
    return Promise.resolve(undefined)
  }

  async onFacetUpdate(facets: IFacet[]): Promise<void> {}

  async onSearchTextUpdate(text: string): Promise<void> {}

  async onResultUpdate(result: MultipleResults): Promise<void> {}

  async whenReady(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (this.core) {
        resolve()
      } else {
        let interval = setInterval(() => {
          if (this.core) {
            clearInterval(interval)
            resolve()
          }
        }, 10)
      }
    })
  }
}
